import { Battery, Factory, Leaf, Shield } from 'lucide-react';
import SectionReveal from './SectionReveal';

const iconMap = { Battery, Factory, Leaf, Shield };
const BESS_IMG = "https://images.unsplash.com/photo-1639195046198-a73b6d2d9606?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxiYXR0ZXJ5JTIwZW5lcmd5JTIwc3RvcmFnZSUyMHN5c3RlbXxlbnwwfHx8fDE3NzQ3OTcyNzR8MA&ixlib=rb-4.1.0&q=85";

function BESSFeatureCard({ feature }) {
  const Icon = iconMap[feature.icon];
  return (
    <div className="group bg-[#111111] border border-white/10 p-7 hover:border-[#D4A017]/35 hover:-translate-y-1 transition-all duration-300 h-full">
      <div className="mb-5 w-11 h-11 flex items-center justify-center border border-[#D4A017]/30 text-[#D4A017] group-hover:bg-[#D4A017]/10 transition-colors duration-200">
        {Icon && <Icon size={20} />}
      </div>
      <h3 className="text-base font-medium text-white mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>{feature.title}</h3>
      <p className="text-sm text-white/55 leading-relaxed">{feature.body}</p>
    </div>
  );
}

function BESSHero({ text }) {
  return (
    <div className="relative overflow-hidden mb-16">
      <img src={BESS_IMG} alt="BESS Gigafactory" className="w-full h-96 sm:h-[480px] object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/93 via-black/72 to-black/30" />
      <div className="absolute inset-0 flex items-center px-8 sm:px-14 lg:px-20">
        <SectionReveal>
          <p className="text-xs tracking-[0.28em] uppercase text-[#D4A017] mb-4 font-medium">{text.label}</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium text-white mb-5 max-w-2xl leading-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>{text.title}</h2>
          <p className="text-base text-white/65 max-w-xl leading-relaxed">{text.subtitle}</p>
        </SectionReveal>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-[#D4A017]/60 via-[#D4A017]/20 to-transparent" />
    </div>
  );
}

export default function BESSSection({ text }) {
  return (
    <section id="bess" className="py-24 sm:py-32 bg-[#0a0a0a]">
      <div className="container mx-auto px-6 lg:px-12 max-w-7xl">
        <BESSHero text={text} />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
          {text.stats.map((stat, i) => (
            <SectionReveal key={stat.label} delay={i * 100}>
              <div className="bg-[#111111] border border-white/10 p-6 text-center hover:border-[#D4A017]/40 transition-colors duration-300">
                <div className="text-2xl sm:text-3xl font-medium text-[#D4A017] mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>{stat.value}</div>
                <div className="text-xs sm:text-sm text-white/50 leading-snug">{stat.label}</div>
              </div>
            </SectionReveal>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {text.features.map((feature, i) => (
            <SectionReveal key={feature.title} delay={i * 100}>
              <BESSFeatureCard feature={feature} />
            </SectionReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
